import type {Project} from '@package/shared'
import {UpdateForm} from '../forms/project/UpdateForm.tsx'
import {Flex, Modal} from '@mantine/core'

type Props = {
  project: Project | undefined
  opened: boolean
  onClose: () => void
}

export const EditProjectModal = ({project, opened, onClose}: Props) => {
  if (!project) return null

  return (
    <Modal opened={opened} onClose={onClose} title={'Edit project'} size={'lg'}>
      <Flex direction={'column'} gap={'sm'}>
        <UpdateForm project={project} onSuccess={onClose} disabled={false} />
      </Flex>
    </Modal>
  )
}
